@import "covet-pics-gallery-item-mixins.scss";
@import "covet-pics-gallery-item-vars.scss";
@import "covet-pics-gallery-item-upload.scss";
@import "covet-pics-gallery-item-default.scss";
@import "covet-pics-gallery-item-basic-1.scss";
@import "covet-pics-gallery-item-basic-2.scss";
@import "covet-pics-gallery-item-basic-3.scss";
@import "covet-pics-gallery-item-basic-4.scss";
@import "covet-pics-gallery-item-basic-5.scss";
@import "covet-pics-gallery-item-basic-6.scss";
@import "covet-pics-gallery-item-modern-1.scss";
@import "covet-pics-gallery-item-modern-2.scss";
@import "covet-pics-gallery-item-modern-3.scss";
@import "covet-pics-gallery-item-modern-4.scss";
@import "covet-pics-gallery-item-modern-5.scss";
@import "covet-pics-gallery-item-modern-6.scss";

// TODO refactor for covet-pics-gallery-item-caption
covet-pics-gallery-item-caption {
  flex-grow: 1;
  display: flex;
  align-items: center;
  position: relative;
}
